module.exports = __webpack_public_path__ + "media/images/homes/InbuildThemes-89b23c83f6f78c8235f1df53e248adf9.png";